import { useState } from "react";
import { TraceDeepCTAPanel } from "./TraceDeepCTAPanel";

export function TracePreviewChip({ insight, onRegisterInterest }: { insight: string; onRegisterInterest: (tier: string) => void }) {
  const [step, setStep] = useState<"collapsed" | "preview" | "deep">("collapsed");
  return (
    <div className="tracePreviewChip">
      <span className="tracePreviewTeaser">Trace interest — service not live</span>
      {step === "collapsed" && (
        <button type="button" className="tracePreviewCta" onClick={() => setStep("preview")}>Preview</button>
      )}
      {step === "preview" && (
        <>
          <button type="button" className="tracePreviewCta" onClick={() => setStep("collapsed")}>Collapse</button>
          <p className="tracePreviewExpanded">{insight}</p>
          <button type="button" className="tracePreviewCta" onClick={() => setStep("deep")}>About Trace</button>
        </>
      )}
      {step === "deep" && (
        <TraceDeepCTAPanel
          onRegisterInterest={() => onRegisterInterest("Trace")}
          onBack={() => setStep("preview")}
        />
      )}
    </div>
  );
}
